module.exports = __webpack_public_path__ + "static/AKHeadshot-21502c1fa70a10c3340aa921445b22fd.jpg";